<template>
  <div class="card">
    <i :class="`${appearance.class}${large ? ' fa-2x' : ''}`" />
    <div
      :class="`ranking-text${large ? ' large' : ''}`"
      :data-test="indicator"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {

  name: 'RankDisplay',
  props: {
    indicator: {
      type: String,
      default: ''
    },
    large: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    appearance () {
      switch (this.indicator) {
      case 'up':
        return {
          class: 'fa fa-arrow-circle-up',
          variant: 'has-text-success'
        }
      case 'down':
        return {
          class: 'fa fa-arrow-circle-down',
          variant: 'has-text-danger'
        }
      case 'noChange':
        return {
          class: 'fa fa-circle',
          variant: 'has-text-dark'
        }
      case 'new':
        return {
          class: 'fa fa-plus',
          variant: 'has-text-info'
        }
      default:
        return {
          class: 'fa fa-plus',
          variant: 'has-text-success'
        }
      }
    }
  }
}
</script>

<style lang="css" scoped>
.ranking-text {
  display: inline-block;
}

.large {
  font-size: 34px;
  margin-left: 5px;
}
.card-body {
  padding: 5px 5px 10px 5px;
}

</style>
